import axios from "axios";
import { api_url } from "../Utils/Urls";

export const API =  axios.create({
  baseURL: api_url,
});